import { NgModule } from '@angular/core';
import { ChipComponent } from './chip.component';

const MODULES = [ChipComponent];

@NgModule({
  imports: MODULES,
  exports: MODULES
})
export class ChipModule {}
